"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgEarthquake(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M14.713 2L15 5l-3 3 2 2-3 4v-4L9 8l3-3-2.43-3H4v14h16V2z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Earthquake')(SvgEarthquake);
//# sourceMappingURL=Earthquake.js.map